import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Drop-in replacement for <input type="password" /> with an accessible
 * show/hide toggle. Forwards every prop the native input accepts (value,
 * onChange, placeholder, required, minLength, data-testid, etc.) so existing
 * forms and tests keep working unchanged.
 */
export const PasswordInput = ({ "data-testid": testId, ...props }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-input-wrapper" data-testid={testId ? `${testId}-wrapper` : undefined}>
      <input
        {...props}
        type={visible ? "text" : "password"}
        data-testid={testId}
        className={`password-input ${props.className || ""}`.trim()}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        className="password-toggle-btn"
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        tabIndex={-1}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};

export default PasswordInput;
